import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      if (!['/login', '/', '/registro', '/gracias', '/privacidad', '/terminos', '/recuperar-password', '/restablecer-password'].includes(window.location.pathname)) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;

// ── Formateador de moneda 100% dinamico ──
// Lee la moneda del tenant desde localStorage (guardada al login desde /auth/me).
// Fallback: MXN.
// Nota: el nombre `formatoMXN` se mantiene por compatibilidad. Ahora formatea
// en la moneda del tenant, con simbolo y decimales correctos por pais.
const getMonedaTenant = () => {
  try {
    const m = JSON.parse(localStorage.getItem('tenant_moneda') || 'null');
    if (m && m.codigo) return m;
  } catch (_) { /* noop */ }
  return { codigo: 'MXN', simbolo: '$', locale: 'es-MX', decimales: 2 };
};

export const formatoMoneda = (valor, opts = {}) => {
  const m = opts.moneda || getMonedaTenant();
  const decimales = m.decimales !== undefined ? m.decimales : 2;
  try {
    return new Intl.NumberFormat(m.locale || 'es-MX', {
      style: 'currency', currency: m.codigo || 'MXN',
      minimumFractionDigits: decimales, maximumFractionDigits: decimales,
    }).format(valor || 0);
  } catch (_) {
    // Fallback manual si el locale/moneda no es soportado por el navegador
    const num = (valor || 0).toLocaleString(m.locale || 'es-MX', {
      minimumFractionDigits: decimales, maximumFractionDigits: decimales,
    });
    return `${m.simbolo || '$'}${num}`;
  }
};

// Alias por compatibilidad con codigo existente que usa formatoMXN.
// Todos los llamados existentes seguiran funcionando y ahora respetan la
// moneda del tenant automaticamente.
export const formatoMXN = formatoMoneda;

export const formatoFecha = (fecha) => {
  if (!fecha) return '';
  return new Date(fecha).toLocaleDateString('es-MX', {
    day: '2-digit', month: 'short', year: 'numeric'
  });
};

export const ESTADOS = {
  recibido: { label: 'Recibido', clase: 'estado-recibido' },
  diagnostico: { label: 'Diagnostico', clase: 'estado-diagnostico' },
  reparando: { label: 'Reparando', clase: 'estado-reparando' },
  terminado: { label: 'Terminado', clase: 'estado-terminado' },
  entregado: { label: 'Entregado', clase: 'estado-entregado' },
  cancelado: { label: 'Cancelado', clase: 'estado-cancelado' },
};

export const PRIORIDADES = {
  baja: { label: 'Baja', clase: 'prioridad-baja' },
  media: { label: 'Media', clase: 'prioridad-media' },
  alta: { label: 'Alta', clase: 'prioridad-alta' },
  urgente: { label: 'Urgente', clase: 'prioridad-urgente' },
};

export const METODOS_PAGO = [
  { valor: 'efectivo', label: 'Efectivo' },
  { valor: 'transferencia', label: 'Transferencia' },
  { valor: 'tarjeta', label: 'Tarjeta' },
  { valor: 'otro', label: 'Otro' },
];
